// extracted by mini-css-extract-plugin
export var container = "Container-module--container--687df";
export var paddingVertical = "Container-module--paddingVertical--24f08";
export var whiteBG = "Container-module--whiteBG--9f44a";
export var grayBG = "Container-module--grayBG--31aa0";
export var blackBG = "Container-module--blackBG--ab395";
export var transparentBG = "Container-module--transparentBG--79355";
export var stairs = "Container-module--stairs--10f69";